import React from 'react';
import { Link } from 'react-router-dom';

//import students from '../../testing/students/students';

import customRequest from '../../helpers/customRequest'
import BeatLoader from 'react-spinners/BeatLoader'
import ClipLoader from 'react-spinners/ClipLoader'
import { initializeFormValidation } from '../../helpers/forms/form-validation';
import message from '../../components/message/message';

import instructionsPDF from '../../content/files/instructions.pdf'
import buildQuery from '../../helpers/buildQuery';

class Dashboard extends React.Component {

    state = {
        initialStudents: [],
        currentStudents: [],
        status : {
            purchased : null,
            used : null,
            transferred: null,
            transferredUsed: null
        },
        loading: true,
        submitting: false
    }

    filterList = (event) => {
        var updatedList = this.state.initialStudents;
        updatedList = updatedList.filter(function (item) {
            return item.display.toLowerCase()
                .indexOf(
                event.target.value.toLowerCase()) !== -1;
        });
        this.setState({ currentStudents: updatedList });
    }

    componentDidMount() {
        let page = this
        customRequest.get("/api/students")
        .then((students) =>
        {
            let studentData = {...students.data};
            if (studentData.valid == false) return
            var currentStudents = []

            studentData.active.forEach((element) => {
                element.owned = true;
                element.display = element.name;
                currentStudents.push(element);
            }, this);
            studentData.shared.forEach((element) => {
                element.owned = false;
                element.display = element.name + " (from " + element.owner + ")";
                currentStudents.push(element)
            }, this);

            page.setState({initialStudents: currentStudents, currentStudents: currentStudents, loading: false})
        })

        customRequest.get("/api/update")
        .then(({data: response}) => {
            if (response.valid && !response.seen) {
                window.$("#welcome-modal")
                .modal()
                .on('hidden.bs.modal', function (e) {
                    customRequest.post("/api/update")
                })
            }
        })

        customRequest.get("/api/status")
        .then(({data:status}) => {
            if (status.valid == false) return
            this.setState({status: status})
        })

        initializeFormValidation(this.onSubmit);
    }

    onSubmit = () => {

        this.setState({submitting: true}, () => {

            message.clear()

            if (document.getElementById("referral-emails").value == "") {
                this.setState({submitting: false})
                return message.error("Enter an email you'd like to refer")
            }

            customRequest.post("/api/account/referral", {
                "emails": document.getElementById("referral-emails").value
            })
            .then(({data: response}) => {
                this.setState({submitting: false})
                document.getElementById("referral-emails").value = ""
                if (response.valid == false) {
                    message.error(response.message)
                }
                else {
                    message.success("Your referral has been sent! Thank you.")
                }
            })
        })
    }

    render() {
        let status = this.state.status
        return (
            <React.Fragment>
                {status.used == 0 ?
                    <React.Fragment>
                        {
                            status.active > 0 ? 
                            <div class="alert alert-info">Before you can start exercises with students, you must create a student. Head to the <Link to="/students">students page</Link> to make your student.</div>
                            :
                            ""
                        }
                    </React.Fragment>
                    :
                    ""
                }

                {status.available < 0 ?
                
                <React.Fragment>
                    {status.active > 0 ? 
                    <div class="alert alert-danger">Due to your previous subscription expiring, you have exceeded the number of students allowed on your account. Your student data has been preserved, but you will not have access to start any exercise with your students until you <strong>delete or archive {Math.abs(status.available)} students</strong> below or <Link to="/subscribe">purchase more students</Link> to continue using the platform.</div>
                    :

                    <div class="alert alert-danger">Your subscription has expired you must <Link to="/subscribe">purchase more students</Link> to continue using the platform.</div>
                    }
                </React.Fragment>
                :
                ""}
                <h1 id="welcome-dashboard-msg">Welcome to your Great&nbsp;Leaps&nbsp;Digital Dashboard!</h1>

                <link rel="stylesheet" type="text/css" href="/styles/dashboard.css" />

                <div class="row subheader-text">
                    <div class="col-xxxs-12 col-sm-6">
                        <Link to="/help/frequently-asked-questions" class="btn btn-secondary btn-lg">Frequently&nbsp;Asked&nbsp;Questions</Link>
                    </div>

                    <div class="col-xxxs-12 col-sm-6">
                        <a href={instructionsPDF} target="_blank" class="btn btn-secondary btn-lg">Instructions&nbsp;with&nbsp;Video</a>
                    </div>
                </div>

                <div class="row">
                    <h2 class="section-header text-left col-12">Get Started</h2>
                    <div class="col-sm-7">
                        <p id="student-search-text" class="float-right">To begin an exercise, please select a student from the list below.</p>
                    </div>

                    <div class="col-sm-3">
                        <input placeholder="Search Students" id="student-search" class="form-control" onChange={this.filterList} />
                    </div>
                </div>

                <div class="row">
                    <div id="student-list" class="home-student-list">
                        {this.state.loading ? <BeatLoader
                                                size={10}
                                                color={"#123abc"}
                                                loading={this.state.loading} /> : 
                            this.state.currentStudents.map((student) => {
                                    return (
                                        <Link to={`/probes/phonics?${buildQuery({customer: student.owner, student: student.name})}`} className="list-group-item break-words list-group-item-action">{student.display}</Link>
                                    )
                            })
                        }
                    </div>
                    <p className="text-center w-100">To add or edit students, please proceed to your <Link to="/students">students page</Link>.</p>
                </div>

                <h2 class="section-header text-left">Helpful Videos</h2>

                <div id="home-carousel" class="carousel slide indicators-bottom center-block" data-ride="carousel" data-interval="false">

                    <div class="carousel-inner" role="listbox">
                        <div class="carousel-item active">
                            <div className="row">
                                <div class="col-sm-4">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://www.youtube-nocookie.com/embed/vD98CEEIpMY?rel=0" allowfullscreen></iframe>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://www.youtube-nocookie.com/embed/3ni69UvQlA8?rel=0" allowfullscreen></iframe>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://www.youtube-nocookie.com/embed/ZolXJrJr6fU?rel=0" allowfullscreen></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div className="row">
                                <div class="col-sm-4">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://www.youtube-nocookie.com/embed/h51TfIYyZ1A?rel=0" allowfullscreen></iframe>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://www.youtube-nocookie.com/embed/zU0xDgUO5aI?rel=0" allowfullscreen></iframe>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://www.youtube-nocookie.com/embed/PVqHt6r1Wjw?rel=0" allowfullscreen></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="carousel-controls carousel-controls-logged-in">
                        <div class="row">
                            <div className="col-4">
                                <a class="carousel-left carousel-control" href="#home-carousel" data-slide="prev">
                                    <span class="fas fa-chevron-left video-arrow"></span>
                                </a>
                            </div>
                            <div className="col-4">
                                <ol class="carousel-indicators carousel-indicators-logged-in indicators-bottom">
                                    <li data-target="#home-carousel" data-pause="true" data-slide-to="0" class="active"></li>

                                    <li data-target="#home-carousel" data-slide-to="1"></li>
                                </ol>
                            </div>
                            <div className="col-4">
                                <a class="carousel-right carousel-control" href="#home-carousel" data-slide="next">
                                    <span class="fas fa-chevron-right video-arrow"></span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
                <h2 class="share-title-container">
                    <span class="share-title d-none d-sm-inline">Share Great Leaps with a student in need!</span>
                    <span class="d-block d-sm-none">Share Great Leaps with a student in need!</span>
                </h2>

                <p>Share Great Leaps Digital with your fellow parents, teachers, and tutors by entering their emails below and we'll send them an invitation.</p>

                <form id="referral-form" class="form-horizontal form-validate" noValidate="" method="post" action="/">
                    <input type="hidden" name="csrf-token" id="share-csrf-token" value="<?php echo $csrfToken; ?>" />

                    <div class="form-group row">
                        <div class="offset-3 col-6">
                            <input type="text" class="form-control" disabled={this.state.submitting} id="referral-emails" name="referral-emails" placeholder="Enter their emails separated with a comma" required="" data-description="enter emails" />
                        </div>
                        <div class="col-3">
                            <button type="submit" class="btn btn-secondary btn-md float-left no-top-margin" disabled={this.state.submitting}>
                                {this.state.submitting ?
                                        <ClipLoader
                                            size={20}
                                            color={"#123abc"}
                                            loading={this.state.submitting}
                                            /> : "Send"}
                            </button>
                        </div>
                    </div>
                </form>
                <div class = "modal" id = "welcome-modal" tabindex = "-1" role = "dialog">
                    <div class = "modal-dialog modal-lg" role = "document">
                        <div class = "modal-content">
                            <div class = "modal-header">
                                <h2 class = "modal-title" id = "stop-modal-label">Welcome to the newly improved Great Leaps Digital Program!</h2>
                            </div>
                            
                            <div class = "modal-body">
                                <div class = "text-left">
                                <h4>Here are some of the new features you will find:</h4>
                                    <ul>
                                        <li><strong>Phrases:</strong> Always learning from our data, we have modified our Sight Phrases section to start students out working on 2 word phrases instead of words in isolation. If you are already working in Section 1 of Sight Phrases the program will automatically switch you to one of our new exercises at the same instructional level.</li>
                                        <li><strong>Placement:</strong> New programming lets you simply do the highlighted exercises. All students start with exercise 1, and the program will do the rest, moving your student quickly to their instructional level.</li>
                                        <li><strong>Tool tips:</strong> Click on the ? to find helpful tips.</li>
                                        <li><strong>Forgot the story:</strong> We have you covered! Simply click the “Review Exercise” button and the story will appear below so you can reference it while you do Depth of Knowledge work with your students.</li>
                                    </ul>
                                    <p>Happy Leaping!</p>
                                </div>
                                <p>As always if you have any questions feel free to contact our customer service department at <a href = "mailto:glsupport@greatleaps.com">glinfo@greatleaps.com</a> or give us a call at <span class = "text-center">(877)&nbsp;475-3277</span></p>
                            </div>
                            
                            <div class = "modal-footer">
                                <button type = "button" class = "btn btn-secondary center-block" data-dismiss = "modal" id = "welcome-modal-button">Okay, got it.</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Dashboard;
